import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Field, Form, getIn, withFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Col, Row } from 'react-bootstrap';
import { debounceIndexEmployeesRequest } from '../../requests/employees';
import { FormikRangePicker, FormikSelect } from '../../components';

const ALL_SELECTED_LABEL = 'Todos';

const ShiftAssignmentsBossFilters = props => {
  const { errors, touched, setFieldValue, values, rrhh, currentEmployee } = props;
  const [employees, setEmployees] = useState([]);
  const [employeeIds, setEmployeeIds] = useState([]);
  const [selectedShift, setSelectedShift] = useState('');
  const [selectedJobTitles, setSelectedJobTitles] = useState('');
  const [loading, setLoading] = useState();
  const [disabled, setDisabled] = useState(false);
  const [placeholder, setPlaceholder] = useState('Seleccione colaboradores');
  const [selectedBranchOffice, setSelectedBranchOffice] = useState([]);
  const dispatch = useDispatch();

  const fetchEmployees = () => {
    setLoading(true);
    setPlaceholder('Cargando colaboradores...');

    const params = {
      active: true,
      sort_column: 'name',
      is_dt: false,
      paginate: false,
      filter_active_branch_offices: selectedBranchOffice,
      filter_job_title: selectedJobTitles,
      filter_active_shifts: selectedShift
    };

    if (rrhh === false) {
      params.employees_belong_boss = currentEmployee;
    }

    debounceIndexEmployeesRequest({
      dispatch,
      params,
      successCallback: response => {
        const dataToGroupSearch = [{ id: 'Todos', label: 'Todos', value: 'Todos' }, ...response.data.data];
        setEmployees(response.data.data.length > 0 ? dataToGroupSearch : []);
        setEmployeeIds(response.data.data.map(emp => emp.id));
        setLoading(false);
        setPlaceholder('Seleccione colaboradores');
        setDisabled(response.data.data.length === 0);
      }
    });
  };

  const fetchData = () => {
    fetchEmployees();
  };

  const hasAllSelection = (groupSelection = []) => {
    return groupSelection.some(option => option.value === ALL_SELECTED_LABEL);
  };

  const handleDisabledSelection = (options, selectedOptions) => {
    if (hasAllSelection(selectedOptions)) {
      return true;
    }
    if (selectedOptions.length === 0) return false;
    return options.value === ALL_SELECTED_LABEL;
  };

  const handleEmployeesSearch = (field, data) => {
    switch (field) {
      case 'filter_active_branch_offices':
        setSelectedBranchOffice(data);
        break;
      case 'filter_job_title':
        setSelectedJobTitles(data);
        break;
      case 'filter_active_shifts':
        setSelectedShift(data);
        break;
      default:
        break;
    }
  };

  const handleNewMulti = (data, field, allowEmpty = false) => {
    const newData = data.map(element => element.value);
    if (newData.length && newData.includes(ALL_SELECTED_LABEL)) {
      newData.push('');
      return;
    }

    if (allowEmpty && !newData.length) newData.push('');
    setFieldValue(field, newData);
    handleEmployeesSearch(field, newData);
  };

  useEffect(fetchData, []);
  useEffect(() => {
    fetchEmployees();
    // eslint-disable-next-line
  }, [selectedBranchOffice, selectedJobTitles, selectedShift]);

  useEffect(() => {
    setFieldValue('employeeIds', employeeIds);
  }, [employeeIds, setFieldValue]);

  return (
    <Form>
      <Row>
        <Col sm={12} md={6} xs={12}>
          <Field name="date_range">
            {({ field }) => (
              <FormikRangePicker
                {...field}
                abbr
                startDateName="date_from"
                endDateName="date_to"
                startDate={values.date_from}
                endDate={values.date_to}
                showClearDates
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col sm={12} md={4} xs={12}>
          <Field name="employees">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Nombres y Apellidos"
                isMulti
                options={employees}
                placeholder={placeholder}
                onChange={data => {
                  handleNewMulti(data || [], 'filter_employee_ids', true);
                  setFieldValue(field.name, data || []);
                  setFieldValue('employee', '');
                  setFieldValue('filter_id', '');
                }}
                isOptionDisabled={handleDisabledSelection}
                isClearable
                isDisabled={loading}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col sm={12} md={2} xs={12} className="mt-4">
          <Button className="btn-block" type="submit" disabled={loading || disabled}>
            Filtrar
          </Button>
        </Col>
      </Row>
      <Field type="hidden" name="employeeIds" value={employeeIds} />
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  date_range: Yup.array().when('filter_offday', {
    is: true,
    then: Yup.array().rangedate(true)
  })
});

const setInitialValues = () => {
  return {
    date_from: '',
    date_to: '',
    date_range: [],
    employees: []
  };
};

const handleSubmit = (values, { props }) => {
  const { formRequest, rrhh } = props;
  const submitValues = { ...values };

  // Si rrhh es falso, siempre enviar el campo employeeIds (aunque esté vacío)
  if (rrhh === false) {
    submitValues.filterEmployeeIds = values.employeeIds || [];
  }

  formRequest(submitValues);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: false
})(ShiftAssignmentsBossFilters);
